import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AUTOMATION_PATH, PROJECTS_PATH, WEBSITES_PATH } from '../routes';
import './Footer.css';

// On every page, so the service pages and the catalogue are always one click
// away — for visitors, and for crawlers weighing which pages matter.
const FOOTER_LINKS = [
  { to: WEBSITES_PATH, key: 'servicePages.websites.eyebrow' },
  { to: AUTOMATION_PATH, key: 'servicePages.automation.eyebrow' },
  { to: PROJECTS_PATH, key: 'navigation.allProjects' }
];

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <span>{t('footer.text')}</span>
      <nav className="footer-links" aria-label={t('servicePages.seeAlso')}>
        {FOOTER_LINKS.map(({ to, key }) => (
          <Link key={to} to={to}>{t(key)}</Link>
        ))}
      </nav>
    </footer>
  );
}

export default Footer;
